import { Button, Dialog } from '@artosera/ui';
import { useTranslation } from 'react-i18next';
import { useEnvoyerCampagne, type CampagneNewsletter } from '../../api/newsletter.js';
import { useShellContext } from '../shell/context.js';
import { ErreurNewsletter } from './ErreurNewsletter.js';
export function EnvoiDialog({
  campagne,
  destinataires,
  expediteur,
  open,
  onOpenChange,
}: {
  campagne: CampagneNewsletter;
  destinataires: number;
  expediteur?: string | null;
  open: boolean;
  onOpenChange: (v: boolean) => void;
}) {
  const { t } = useTranslation(['regie', 'commun']);
  const { galerieSlug } = useShellContext();
  const envoyer = useEnvoyerCampagne(galerieSlug);
  return (
    <Dialog
      open={open}
      onOpenChange={onOpenChange}
      title={t('regie:newsletter.campagne.envoiTitre')}
      closeLabel={t('commun:actions.fermer')}
    >
      <p>
        {t('regie:newsletter.campagne.confirmation', {
          sujet: campagne.sujet,
          count: destinataires,
        })}
      </p>
      {expediteur ? <p>{t('regie:newsletter.envoi.expediteur', { expediteur })}</p> : null}
      <p>{t('regie:newsletter.campagne.consentement')}</p>
      <ErreurNewsletter erreur={envoyer.error} />
      <Button
        disabled={envoyer.isPending}
        onClick={() => {
          void envoyer
            .mutateAsync(campagne.id)
            .then(() => onOpenChange(false))
            .catch(() => {});
        }}
      >
        {t('regie:newsletter.campagne.envoyerMaintenant')}
      </Button>
    </Dialog>
  );
}
